import Service from "./Service"

class StickyNoteService extends Service {

    findNoteOfCurrentUser = () => this.get("/sticky-notes")

    upsertStickyNote = (requestBody) => this.patch("/sticky-notes", requestBody)
}

const stickyNoteService = new StickyNoteService()
export default stickyNoteService